/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';

import { StylingContextState } from 'context/Styling';

export const termsAndConditionsModalStyles = ({ colors, viewport: { md } }: StylingContextState) => ({
  content: css`
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    padding: 0rem 1rem;
  `,
  header: css`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 1rem;
    text-align: center;
    padding: 1rem 0rem;
  `,
  heading: css`
    margin: 0;
    font-size: 2.5rem;
    font-weight: 700;
    line-height: 1.3;
    color: ${colors.text.primary};
  `,
  description: css`
    margin: 0;
    color: ${colors.text.secondary};
    line-height: 1.5;
    text-align: left;

    a {
      text-decoration: underline;
    }
  `,
  actions: css`
    display: flex;
    flex-direction: ${md ? 'row' : 'column-reverse'};
    gap: 0.5rem;
    align-items: center;
    justify-content: flex-end;
    margin-top: 0.5rem;
  `,
  secondaryButton: css`
    min-width: ${md ? '140px' : 'auto'};
    height: 32px;
    line-height: 30px;
    padding: 0 15px;
    justify-content: center;

    &:hover {
      background-color: ${colors.action.hover};
      color: ${colors.text.primary};
    }

    &:focus {
      background-color: ${colors.action.hover};
      color: ${colors.text.primary};
    }
  `,
  primaryButton: css`
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: ${md ? '140px' : 'auto'};
    height: 32px;
    line-height: 30px;
    padding: 0px 20px;
    flex-direction: row-reverse;
  `,
});
